// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetRegionPlanningPartnerDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import RegionalPlanningPartnerDTO from '../models/RegionalPlanningPartnerDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
    academicYear: number | null | null;
    rppId: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
            academicYear: null,
            rppId: null,
        },
        initValues);
    },
    id: 'id',
    academicYear: 'academicYear',
    rppId: 'rppId',
}

interface Result extends ResultDTO {
    regionPlanningPartner: RegionalPlanningPartnerDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            regionPlanningPartner: null,
        },
        initValues);
    },
    regionPlanningPartner: 'regionPlanningPartner',
}

export { Request, Result };